import { useMemo } from 'react';

import { Speaker } from '@/types/speakers.types';

type Props = {
  defaultSpeaker?: Speaker | null;
  initialName?: string;
};

const useInitializeNameGuess = ({ defaultSpeaker, initialName }: Props) => {
  const includesAt = initialName?.includes('@');
  const first = defaultSpeaker?.first_name;
  const last = defaultSpeaker?.last_name;
  const email = defaultSpeaker?.email;
  const initialFirstNameGuess = first || (includesAt ? '' : initialName?.trim()?.split(' ')?.[0]);
  const initialLastNameGuess = last || (includesAt ? '' : initialName?.trim()?.split(' ')?.slice(1).join(' '));
  const emailGuess = email || (includesAt ? initialName?.replaceAll(' ', '') : '');

  return useMemo(
    () => ({
      email: emailGuess || '',
      first_name: initialFirstNameGuess || '',
      last_name: initialLastNameGuess || '',
    }),
    [emailGuess, initialFirstNameGuess, initialLastNameGuess]
  );
};

export default useInitializeNameGuess;
